import './_rollupPluginBabelHelpers-8c92bac3.js';
import React__default, { useContext } from 'react';
import 'classnames';
import { T as ThemeContext } from './ThemeContext-e1f446be.js';
import Tippy from '@tippy.js/react';
import Theme from './theme.js';
import { i as isArray } from './helpers-1066b771.js';

const maxWidthFallback = 288;

// legacy conversion
const whitelistPlacement = placement => {
  const whitelist = {
    top: 'top',
    right: 'right',
    bottom: 'bottom',
    left: 'left',
    center: 'top',
    topLeft: 'top-start',
    topRight: 'top-end'
  };
  return whitelist[placement] || 'top';
};
const renderChildren = children => {
  const child = isArray(children) ? children[0] : children;

  // for components you don't have access to set ref, wrap in <span>
  // @ref https://github.com/atomiks/tippy.js-react/issues/49#issuecomment-470198792
  if (typeof child.type === 'function') {
    return /*#__PURE__*/React__default.createElement("span", null, child);
  } else {
    return child;
  }
};
const Tooltip = props => {
  const context = useContext(ThemeContext);
  const appTheme = context && context.theme;
  let {
    children,
    visible,
    placement,
    overlay,
    arrow = true,
    appendTo,
    maxWidth = maxWidthFallback,
    flipBehavior = 'flip',
    flipOnUpdate = false,
    interactive = false,
    boundary = 'window',
    className = 'mw-tooltip--default',
    tooltipTheme = 'dark'
  } = props;
  const tooltipContent = /*#__PURE__*/React__default.createElement(Theme, {
    theme: appTheme,
    doNotAlterChildren: true
  }, overlay);

  // "appendTo" defaults to "parent" instead of "document.body" if "interactive: true"
  // need to explicitly set "document.body"
  if (!appendTo && typeof window !== 'undefined') {
    appendTo = document.body;
  }
  return /*#__PURE__*/React__default.createElement(Tippy, {
    arrow: arrow,
    visible: visible,
    content: tooltipContent,
    className: `mw-tooltip mw-tooltip--${tooltipTheme}-mode ${className}`,
    theme: tooltipTheme,
    placement: whitelistPlacement(placement),
    flip: true,
    flipBehavior: flipBehavior,
    flipOnUpdate: flipOnUpdate,
    interactive: interactive,
    appendTo: appendTo,
    maxWidth: maxWidth,
    boundary: boundary,
    animation: "fade",
    hideOnClick: false,
    zIndex: 999,
    distance: 16
  }, renderChildren(children));
};
Tooltip.defaultProps = {
  placement: 'top'
};

export default Tooltip;
export { Tooltip };
